import React from "react";
import TopNavBar from "../../common/Header/TopNavBar";
import Footer from "../../common/Footer/Footer";
import BannerSlide from "../../Sections/BannerSlides";
import Search from "../../common/Search";
import Track1Card from "./TrackComponents/Track1Card";
import Track2Card from "./TrackComponents/Track2Card";
import Track3Card from "./TrackComponents/Track3Card";
import TrackList from "./TrackComponents/TrackList";
import { backendTrack, frontendTrack, versionTrack } from "./TrackComponents/track.dto";

function TrainingModule() {
  return (
    <>
      <TopNavBar />
      <BannerSlide />

      <div className="containerS p-3 training  m-0">
        <h1 className="text-center mb-4 training-heading">Training Modules</h1>

        <div className="row">
          <div className="col-9">
            <Track1Card />

            <Track2Card />

            <Track3Card />
          </div>

          <div className="col-3 mt-3">
          <Search frontendData={frontendTrack} backendData={backendTrack} versionData={versionTrack} />
           <TrackList />

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default TrainingModule;
